import amapi from '@/api/amapi'
import { SERVICE_TYPES } from '@/consts/service'

export const initialState = () => ({
  websites: [],
  websitesStatus: 'idle', // idle | loading | error
})

export const state = initialState

const getters = {
  getWebsites: state => state.websites,
  websitesStatus: state => state.websitesStatus,
  // Merge websites with their corresponding services:
  websitesMerged: (state, getters, rootState, rootGetters) => {
    let usedIds = []

    let websites = state.websites.reduce((carry, ws) => {
      const service = rootGetters.services.find(srv => srv.id == ws.service_id)
      if (service) {
        usedIds.push(service.id)
        carry.push({
          ...ws,
          serviceId: service.id,
          status: service.status,
          mainDomain: service.domain,
          hostingPlan: service.name,
          user: service.domain !== ws.domain && ws.domaintype === 'main' ? ws.username : undefined,
        })
      }

      return carry
    }, [])

    if (!usedIds.length) {
      return websites
    }

    // Find services that are not linked to any website
    const unlinkedServices = rootGetters.services.filter(srv => !(usedIds.includes(srv.id)) && !srv.related_service && srv.type !== SERVICE_TYPES.OTHER)
    for (const srv of unlinkedServices) {
      websites.push({
        serviceId: srv.id,
        domain: srv.domain,
        status: srv.status,
        mainDomain: srv.domain,
        hostingPlan: srv.name,
        _unlinked: true,
      })
    }

    return websites
  },
}

const mutations = {
  CLEAR_WEBSITES (state) {
    state.websites = []
  },
  SET_WEBSITES (state, websites) {
    state.websites = websites
  },
  SET_WEBSITES_STATUS (state, status) {
    if (['idle', 'loading', 'error'].includes(status) === false) return

    state.websitesStatus = status
  },
}

const actions = {
  clearWebsites ({ commit, state }, isForce = false) {
    if (isForce) {
      commit('CLEAR_WEBSITES')
      commit('SET_WEBSITES_STATUS', 'idle')
    }
  },
  async loadWebsites ({ commit, state }) {
    if (state.websitesStatus === 'loading') {
      return
    }
    commit('SET_WEBSITES_STATUS', 'loading')

    try {
      const response = await amapi.makecall('websites')
      commit('SET_WEBSITES', response.websites)
    } catch (e) {
      commit('SET_WEBSITES_STATUS', 'error')
      throw e
    }

    commit('SET_WEBSITES_STATUS', 'idle')
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
